import styled from 'styled-components';
import { mobile } from 'styles/breakpoints';
import { Button } from 'styles/elements';

export const LogoBackground = styled.div`
  position: absolute;
  height: 100%;
  width: 720px;
  top: 10%;
  right: 2%;

  ${mobile()} {
    display: none;
  }
`;

export const LogoutButton = styled(Button)`
  background-color: ${({ theme }) => theme.color.error};
  border-color: ${({ theme }) => theme.color.error};
  width: 100%;
  height: auto;
  font-size: 16px;
  padding: 14px 12px;
  line-height: 1;
  max-width: 400px;
  margin: 0 auto;

  &:hover {
    color: ${({ theme }) => theme.color.error};
    background-color: ${({ theme }) => theme.color.textPrimary};
  }
`;
